var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSelectArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19028 8.74979L0.809717 8.74979C0.580297 8.74979 0.387989 8.66748 0.232793 8.50287C0.0775978 8.33826 -2.63827e-08 8.14622 -3.59765e-08 7.92674C-3.89745e-08 7.85815 0.0101214 7.78614 0.0303643 7.71069C0.0506072 7.63525 0.0809716 7.56323 0.121457 7.49464L4.31174 0.786823C4.39271 0.663366 4.49393 0.570774 4.61538 0.509045C4.73684 0.447317 4.86505 0.416452 5 0.416452C5.13495 0.416452 5.26316 0.447317 5.38462 0.509045C5.50607 0.570774 5.60729 0.663366 5.68826 0.786823L9.87854 7.49464C9.91903 7.56323 9.94939 7.63525 9.96963 7.71069C9.98988 7.78614 10 7.85815 10 7.92674C10 8.14622 9.9224 8.33826 9.76721 8.50287C9.61201 8.66748 9.4197 8.74979 9.19028 8.74979Z",
    fill: "#C7C7C7"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSelectArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/select_arrow.1e1a39875a1576126200fd0e794091be.svg";